import { Text, View } from '@react-pdf/renderer'

import { styles } from '../styles'

export const SkopFooter = ({ settings }) => (
  <View
    fixed
    style={[
      styles.section,
      {
        flexGrow: 1,
        textAlign: 'center',
        justifyContent: 'flex-end',
        marginBottom: '2.5cm',
        marginTop: '0.5cm',
      },
    ]}
  >
    <View style={{ display: 'flex', flexDirection: 'row' }}>
      <Text style={{ ...styles.titleText, flexGrow: 1 }}>
        {settings?.legal}
      </Text>
      <Text
        style={{ ...styles.titleText, textAlign: 'right' }}
        render={({ pageNumber, totalPages }) => {
          return `${pageNumber} / ${totalPages}`
        }}
      />
    </View>
  </View>
)
